<template>
  <div
    :class="{'mobile': !isDesktop, 'premium': user && user.group === 777, 'dark': darkTheme}"
    class="main-block"
  >
    <!-- <MovieAds v-if="(!user || user.group === 1)" /> -->

    <!-- <div v-if="isDesktop && (!user || user.group === 1)" v-show="showVideoAd" class="videoroll">
      <div @click="showVideoAd = !showVideoAd" style="text-align:right;">
        <i class="close" />
      </div>
      <div class="body">
        <div id="yandex_rtb_R-A-1740435-12"></div>
      </div>
    </div> -->

    <div v-if="isDesktop" class="main-menu">
      <div class="wrapper">
        <div class="one">
          <div class="logotype">
            <nuxt-link to="/">
              <span style="display:inline-block;width:25px;vertical-align:middle;">
                <svg viewBox="0 0 25 27" xmlns="http://www.w3.org/2000/svg">
                  <g fill="none" fill-rule="evenodd">
                    <g>
                      <path d="m11.8603762.08914603c-2.73427441 1.85518864-3.60103382 5.48099179-1.9065094 8.34827534l10.7693764 18.23947693c.146643.2482802.4798267.3159395.7208693.1523805 2.7345754-1.8551886 3.6011843-5.4809918 1.9063587-8.3488637l-10.7689247-18.23874147c-.1467936-.24842731-.4799773-.31608661-.7211703-.1525276" fill="#ee7203"></path>
                      <path d="m12.8919358 20.6222733c0-3.4778352-2.8858858-6.297316-6.44596791-6.297316-3.55993158 0-6.44596789 2.8194808-6.44596789 6.297316s2.88603631 6.297316 6.44596789 6.297316c3.56008211 0 6.44596791-2.8194808 6.44596791-6.297316" fill="#fb471f"></path>
                    </g>
                  </g>
                </svg>
              </span>
              <span>
                Аниме — и точка
              </span>
            </nuxt-link>
          </div>
          <Search />
          <div class="right">
            <span>Приложение</span>
            <button @click="showUserMenu = true">{{ user ? 'Профиль' : 'Войти' }}</button>
          </div>
        </div>
        <div class="two">
          <div class="item">
            <nuxt-link to="/?page=1&year=2025&sort=date">Новинки 2025</nuxt-link>
          </div>
          <div class="item">
            <nuxt-link to="/?page=1&status=ongoing">Онгоинги</nuxt-link>
          </div>
          <div class="item">
            <nuxt-link to="/?page=1&status=released">Завершенные</nuxt-link>
          </div>
          <div class="item">
            <nuxt-link :to="`/?page=1&year=${new Date().getFullYear() - 1}&sort=rating`">Топ {{ new Date().getFullYear() - 1 }}</nuxt-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="main-menu">
      <div class="wrapper">
        <div class="icon-burger"></div>
        <div @click="showSearch = true" class="icon-search"></div>
        <div class="logotype">
          <nuxt-link to="/">
            <span style="display:inline-block;width:20px;vertical-align:middle;margin-right:-5px;">
              <svg viewBox="0 0 35 27" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd">
                  <g>
                    <path d="m11.8603762.08914603c-2.73427441 1.85518864-3.60103382 5.48099179-1.9065094 8.34827534l10.7693764 18.23947693c.146643.2482802.4798267.3159395.7208693.1523805 2.7345754-1.8551886 3.6011843-5.4809918 1.9063587-8.3488637l-10.7689247-18.23874147c-.1467936-.24842731-.4799773-.31608661-.7211703-.1525276" fill="#ee7203"></path>
                    <path d="m12.8919358 20.6222733c0-3.4778352-2.8858858-6.297316-6.44596791-6.297316-3.55993158 0-6.44596789 2.8194808-6.44596789 6.297316s2.88603631 6.297316 6.44596789 6.297316c3.56008211 0 6.44596791-2.8194808 6.44596791-6.297316" fill="#fb471f"></path>
                  </g>
                </g>
              </svg>
            </span>
            <span>
              Аниме — и точка
            </span>
          </nuxt-link>
        </div>
        <button @click="showUserMenu = true">{{ user ? 'Профиль' : 'Войти' }}</button>

        <Search v-if="showSearch" @close="closeSearch" />
      </div>
    </div>

    <div v-if="showUserMenu" class="user-menu">
      <div class="wrap">
        <i @click="showUserMenu = false" class="close" />

        <template v-if="user">
          <div style="font-size:1.2rem;opacity:0.5;width:200px;">
            ID: {{ user.id }}
          </div>

          <div style="display:grid;grid-template-columns:130px auto;grid-gap:15px;align-items:center;">
            <div class="user-photo">
              <div @click="avatarUploadTrigger" class="avatar">
                <img :src="user.photo" alt="">
                <span>Изменить</span>
              </div>
            </div>

            <div>
              <div class="user-name">
                <strong>{{ user.name }}</strong>
                <i @click="showEditName = !showEditName" class="edit" />
                <div style="font-size:1.4rem;">{{ user.email }}</div>

                <div v-if="showEditName">
                  <input v-model="newName" type="text" min="3" max="30" placeholder="Новое имя">
                  <div>
                    <button @click="changeName" class="nickname">
                      Изменить
                    </button>
                    <button @click="showEditName = !showEditName" class="nickname">
                      Отменить
                    </button>
                  </div>
                  <p style="font-size:1.2rem;">Первая смена бесплатно, 2-я и последующие 10руб.</p>
                </div>
                <input
                  ref="avatarUpload"
                  type="file"
                  style="display:none;"
                  accept="image/gif, image/png, image/jpeg, image/jpg"
                  @change="uploadFile($event, 'avatar')"
                >
              </div>

              <div class="user-premium">
                <nuxt-link to="/donate" tag="span">
                  <b
                    style="margin-right:2px;padding:0px 7px;color:#000;border-radius:20px;background-color:#fad200;"
                  >Premium</b>
                  <template v-if="user.group === 777">до {{ user.premium_date | filterDate }}</template>
                  <template v-else>Подключить</template>
                </nuxt-link>
              </div>
              <div class="user-balance">
                <nuxt-link to="/donate">
                  Баланс: <b style="vertical-align:middle;">{{ user.balance }} +</b>
                </nuxt-link>
              </div>
            </div>
          </div>
          <div>
            <nuxt-link to="/profile/history">История просмотров</nuxt-link>
          </div>
          <div>
            <nuxt-link to="/profile/favorites">Избранное</nuxt-link>
          </div>
          <div>
            <nuxt-link to="/donate">Подписка</nuxt-link>
          </div>
          <div>
            <span @click="logout" style="cursor:pointer;">Выйти</span>
          </div>
        </template>
        <template v-else>
          <div class="socials">
            <strong>Используйте для входа</strong>
            <div class="items">
              <div @click="login('google')" class="item">
                <img src="/static_files/icons/signin/google.png" alt="google">
              </div>
              <div @click="login('mailru')" class="item">
                <img src="/static_files/icons/signin/mailru.png" alt="mailru">
              </div>
              <div @click="login('yandex')" class="item">
                <img src="/static_files/icons/signin/yandex.png" alt="yandex">
              </div>
            </div>
          </div>
        </template>

        <div class="footer">
          <button @click="switchTheme" :class="{'active': darkTheme}">Темная тема</button>
        </div>
      </div>
    </div>
 
    <div class="main-wrapper" >
      <Recommends keep-alive />

      <nuxt />
    </div>

    <div class="main-footer">
      <div class="wrapper">
        <a href="mailto:support@animeitochka.ru">support@animeitochka.ru</a>
        <a href="https://vk.com/animeitochkaru" target="_blank">ВКонтакте</a>
      </div>
    </div>

    <Error v-if="error" :error="error" />
  </div>
</template>

<script>
// import LazyHydrate from 'vue-lazy-hydration'
import Vue from 'vue'
import { mapState } from 'vuex'
import global from '~/mixins/global.js'

Vue.mixin(global)

export default {
  components: {
    Error: () => import('~/components/Error.vue'),
    // ChristmasLights: () => import('~/components/ChristmasLights.vue'),
    // Snow: () => import('~/components/Snow.vue'),
    // MovieAds: () => import('~/components/MovieAds.vue'),
    // SH: () => import('~/components/SH.vue'),
    Recommends: () => import('~/components/Recommends.vue'),
    Search: () => import('~/components/Search.vue'),
  },
  filters: {
    filterDate(value) {
      const day = new Date(value).getDate() < 10
        ? '0' + new Date(value).getDate() : new Date(value).getDate()
      const month = (new Date(value).getMonth() + 1) < 10
        ? '0' + (new Date(value).getMonth() + 1) : (new Date(value).getMonth() + 1)
      const year = new Date(value).getFullYear()
      const hour =
        new Date(value).getHours() >= 10
          ? new Date(value).getHours()
          : '0' + new Date(value).getHours()
      const min =
        new Date(value).getMinutes() >= 10
          ? new Date(value).getMinutes()
          : '0' + new Date(value).getMinutes()
      return `${day}.${month}.${year} ${hour}:${min}`
    }
  },
  watch: {
    changeRoute() {
      document.body.style.overflow = ''

      if (!this.isDesktop) {
        this.showSearch = false
      }

      this.showUserMenu = false
      this.showEditName = false
      this.newName = ''
    },
    tabActive(val) {
      console.log('tabActive', val)
    },
    showUserMenu(val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
  },
  computed: {
    ...mapState(['error', 'isDesktop', 'user', 'tabActive',]),
    changeRoute() {
      return this.$route.fullPath
    },
  },
  data() {
    const christmasTime = (new Date().getMonth() === 11 && new Date().getDate() > 15) || (new Date().getMonth() === 0 && new Date().getDate() < 15)

    return {
      christmasTime,
      showVideoAd: true,
      showSearch: false,
      showUserMenu: false,
      showEditName: false,
      newName: '',
      darkTheme: false,
    }
  },
  mounted() {
    // if (this.user && this.$route.query.promo) {
    //   this.postPromo()
    // }

    // this.showAds()

    const vm = this

    if (localStorage.getItem('theme')) {
      const darkTheme = localStorage.getItem('theme') === 'dark'

      this.darkTheme = darkTheme
    }

    window.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        vm.showUserMenu = false
      }
    })

    window.addEventListener('scroll', () => {
      const menuElem = document.querySelector('.main-menu')

      const currentPosition = document.documentElement.scrollTop

      if (currentPosition) {
        menuElem.classList.add('sticky')
      } else {
        menuElem.classList.remove('sticky')
      }
    })

    let hidden = "hidden";

    // Standards:
    if (hidden in document) {
      document.addEventListener("visibilitychange", onchange);
    } else if ((hidden = "mozHidden") in document) {
      document.addEventListener("mozvisibilitychange", onchange);
    } else if ((hidden = "webkitHidden") in document) {
      document.addEventListener("webkitvisibilitychange", onchange);
    } else if ((hidden = "msHidden") in document) {
      document.addEventListener("msvisibilitychange", onchange);
    } else if ("onfocusin" in document) {
      // IE 9 and lower:
      document.onfocusin = document.onfocusout = onchange;
    } else {
      // All others:
      window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;
    }

    function onchange (evt) {
      const v = "visible"
      const h = "hidden"
      const evtMap = {
        focus: v,
        focusin: v,
        pageshow: v,
        blur: h,
        focusout: h,
        pagehide: h
      };

      evt = evt || window.event;

      if (evt.type in evtMap) {
        document.body.className = evtMap[evt.type];
        if (vm.isDesktop) {
          // if (!vm.playerPlay)
          vm.$store.commit('setTabActive', evtMap[evt.type] === 'hidden' ? 0 : 1)
        } else {
          vm.$store.commit('setTabActive', evtMap[evt.type] === 'hidden' ? 0 : 1)
        }
      } else {
        document.body.className = this[hidden] ? "hidden" : "visible";
        if (vm.isDesktop) {
          // if (!vm.playerPlay)
          vm.$store.commit('setTabActive', this[hidden] ? 0 : 1)
        } else {
          vm.$store.commit('setTabActive', this[hidden] ? 0 : 1)
        }
      }
      // console.log(vm.tabActive)
    }

    // set the initial state (but only if browser supports the Page Visibility API)
    if (document[hidden] !== undefined) {
      onchange({ type: document[hidden] ? "blur" : "focus" });
    }

    document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px')
    window.addEventListener('resize', () => { 
      document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px')
    })
  },
  methods: {
    switchTheme() {
      if (this.darkTheme) {
        localStorage.setItem('theme', '')
      } else {
        localStorage.setItem('theme', 'dark')
      }
      this.darkTheme = !this.darkTheme
    },
    async changeName() {
      if (!this.user) return
      const badName = ['admin', 'administrator', 'moderator', 'админ', 'бот', 'администратор']
      if (
        !this.newName.trim() ||
        badName.includes(this.newName.toLowerCase()) ||
        this.newName.match(/[^a-zA-Zа-яА-Я0-9 _].+/)
      ) {
        this.$store.commit('setError', { status: 'warn', msg: 'Неверный формат никнейма' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else if (this.newName.trim().length < 3) {
        this.$store.commit('setError', { status: 'warn', msg: 'Слишком короткое имя (мин. 3)' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else if (this.newName.trim().length > 30) {
        this.$store.commit('setError', { status: 'warn', msg: 'Слишком длинное имя (макс. 30)' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else {
        const { data } = await this.$axios.post('/api/user/nickname', { name: this.newName.trim() })
        if (data.error) {
          this.$store.commit('setError', { status: 'warn', msg: data.error.message })
        } else {
          const user = this.user
          user.name = data.name
          this.$store.commit('setUser', user)
          this.newName = ''
          this.showEditName = false
          this.$store.commit('setError', { status: 'ok', msg: 'Никнейм успешно изменен' })
        }
        setTimeout(() => this.$store.commit('clearError'), 2000)
      }
    },
    avatarUploadTrigger() {
      this.$refs.avatarUpload.click()
    },
    uploadFile(event, typeImg) {
      const file = event.target.files[0]

      if (file) {
        const fileType = file.type
        const imageExt = file.name.slice(file.name.lastIndexOf('.'))
        const imageSize = file.size / 1024

        if (
          (imageExt === '.gif' && imageSize < 1000) ||
          (imageExt === '.jpeg' && imageSize < 5000) ||
          (imageExt === '.jpg' && imageSize < 5000) ||
          (imageExt === '.png' && imageSize < 5000)
        ) {
          const vm = this

          const reader = new FileReader()
          reader.readAsDataURL(file)

          reader.onloadend = function() {
            const image = new Image()
            image.src = reader.result

            image.onload = async function() {
              let maxWidth, maxHeight, finalFile

              if (typeImg === 'avatar') {
                maxWidth = 120
                maxHeight = 120
              }

              if (typeImg === 'avatar' && imageExt === '.gif') {
                finalFile = reader.result
              } else {
                let imageWidth = image.width
                let imageHeight = image.height

                if ((imageWidth > imageHeight) && (imageWidth > maxWidth)) {
                  imageHeight *= maxWidth / imageWidth
                  imageWidth = maxWidth
                } else if (imageHeight > maxHeight) {
                  imageWidth *= maxHeight / imageHeight
                  imageHeight = maxHeight
                }

                const canvas = document.createElement('canvas')
                canvas.width = imageWidth
                canvas.height = imageHeight

                const ctx = canvas.getContext('2d')
                ctx.drawImage(this, 0, 0, imageWidth, imageHeight)

                finalFile = canvas.toDataURL(fileType)
              }

              // The resized file ready for upload
              const fileName = `${vm.user.id}${imageExt}`

              const arr = finalFile.split(',')
              const mime = arr[0].match(/:(.*?);/)[1]
              const bstr = atob(arr[1])
              let n = bstr.length
              const u8arr = new Uint8Array(n)

              while (n--) u8arr[n] = bstr.charCodeAt(n)

              const imageFile = new File([u8arr], fileName, { type: mime })

              vm.$store.commit('setError', { status: 'load', msg: 'Идет загрузка' })

              const bodyFormData = new FormData()
              bodyFormData.append('image', imageFile)

              const { data } = await vm.$axios({
                method: 'post',
                url: `/upload?type=${typeImg}s`,
                data: bodyFormData,
                headers: { 'Content-Type': 'multipart/form-data' }
              })
              vm.$store.commit('setError', { status: 'ok', msg: 'Аватар установлен' })
              setTimeout(() => vm.$store.commit('clearError'), 1000)
              if (typeImg === 'avatar') {
                await vm.$axios.post('/api/user/avatar', { photo: data.url })
                const user = vm.user
                user.photo = data.url
                vm.$store.commit('setUser', user)
              }
            }
          }
        } else {
          this.$store.commit(
            'setError',
            'Файл не соответствует условиям: формат .gif, .jpg, .jpeg или .png размером до 5Mb'
          )
          setTimeout(() => this.$store.commit('clearError'), 3000)
        }
      } else {
        this.$store.commit('setError', 'Ошибка загрузки')
        setTimeout(() => this.$store.commit('clearError'), 2000)
      }
    },
    closeSearch() {
      this.showSearch = false
    },
    async postPromo() {
      const { data } = await this.$axios.post(`/api/user/promo`, { promo: this.$route.query.promo })

      if (!data.error) {
        location.href = '/chat'
      }
    },
    showAds() {
      if (!this.user || this.user.group === 1) {
        setInterval(() => {
          this.showVideoAd = true
        }, 5 * 60 * 1000)

        const rsya1 = document.createElement('script')
        rsya1.innerHTML = `window.yaContextCb = window.yaContextCb || []`
        document.head.appendChild(rsya1)

        const rsya2 = document.createElement('script')
        rsya2.src = `https://yandex.ru/ads/system/context.js`
        rsya2.async = true
        document.head.appendChild(rsya2)

        setTimeout(() => {
          const rsyaHorizon = document.createElement('script')
          rsyaHorizon.innerHTML = `
  window.yaContextCb.push(()=>{
    Ya.Context.AdvManager.render({
      renderTo: 'yandex_rtb_R-A-1740435-5',
      blockId: 'R-A-1740435-5'
    })
  })`
        document.body.appendChild(rsyaHorizon)

        if (!this.isDesktop) {
          const rsyaMobileFS = document.createElement('script')
          rsyaMobileFS.innerHTML = `
  window.yaContextCb.push(()=>{
    Ya.Context.AdvManager.render({
      type: 'fullscreen',
      blockId: 'R-A-1740435-4'
    })
  })`
          document.body.appendChild(rsyaMobileFS)

          const rsyaFooterMobile = document.createElement('script')
          rsyaFooterMobile.innerHTML = `
  window.yaContextCb.push(()=>{
    Ya.Context.AdvManager.render({
      type: 'floorAd',
      blockId: 'R-A-1740435-10'
    })
  })`
          document.body.appendChild(rsyaFooterMobile)
        } else {
          const rsyaDesktopVideoAd = document.createElement('script')
          rsyaDesktopVideoAd.innerHTML = `
  window.yaContextCb.push(()=>{
    Ya.Context.AdvManager.render({
      renderTo: 'yandex_rtb_R-A-1740435-12',
      blockId: 'R-A-1740435-12'
    })
  })
    `
          document.body.appendChild(rsyaDesktopVideoAd)

          const rsyaLeft = document.createElement('script')
          rsyaLeft.innerHTML = `
  window.yaContextCb.push(()=>{
    Ya.Context.AdvManager.render({
      renderTo: 'yandex_rtb_R-A-1740435-14',
      blockId: 'R-A-1740435-14'
    })
  })`
        document.body.appendChild(rsyaLeft)
        }
        }, 200)
      }
    },
    async logout() {
      await this.$axios.get('/api/auth/logout')
      this.$store.commit('setUser', null)
      location.reload()
    },
    login(social) {
      const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=900,height=600,left=10,top=10`
      window.open(`/api/auth/${social}`, `Sign in site - ${social}`, params)
    },
  },
}
</script>
